export const Hotkeys = {
  FieldingSequence: {
    Option: {
      keyCode: 48,
      hotkeyDisplay: '0',
    },
    LeftFielder: {
      keyCode: 55,
      hotkeyDisplay: '7',
    },
    CenterFielder: {
      keyCode: 56,
      hotkeyDisplay: '8',
    },
    RightFielder: {
      keyCode: 57,
      hotkeyDisplay: '9',
    },
    ShortStopper: {
      keyCode: 54,
      hotkeyDisplay: '6',
    },
    SecondBaseman: {
      keyCode: 52,
      hotkeyDisplay: '4',
    },
    ThirdBaseman: {
      keyCode: 53,
      hotkeyDisplay: '5',
    },
    Pitcher: {
      keyCode: 49,
      hotkeyDisplay: '1',
    },
    FirstBaseman: {
      keyCode: 51,
      hotkeyDisplay: '3',
    },
    Catcher: {
      keyCode: 50,
      hotkeyDisplay: '2',
    },
    ExitSequence: {
      keyCode: 27,
      hotkeyDisplay: 'Esc',
    },
    ChangeSelection: {
      keyCode: 67,
      hotkeyDisplay: 'C',
    },
    SaveAndExit: {
      keyCode: 70,
      hotkeyDisplay: 'F',
    },
  },
  BaseRunners: {
    Option: {
      keyCode: 82,
      hotkeyDisplay: 'R',
    },
    ExitSequence: {
      keyCode: 27,
      hotkeyDisplay: 'Esc',
    },
    FinishProcess: {
      keyCode: 70,
      hotkeyDisplay: 'F',
    },
    UndoRemovePlayer: {
      keyCode: 81,
      hotkeyDisplay: 'Q',
    },
  },
  CatcherThrow: {
    Option: {
      keyCode: 67,
      hotkeyDisplay: 'C',
    },
    LeftFielder: {
      hotkeyCode: 55,
      hotkeyDisplay: '7',
    },
    CenterFielder: {
      hotkeyCode: 56,
      hotkeyDisplay: '8',
    },
    RightFielder: {
      hotkeyCode: 57,
      hotkeyDisplay: '9',
    },
    ShortStopper: {
      hotkeyCode: 54,
      hotkeyDisplay: '6',
    },
    SecondBase: {
      hotkeyCode: 52,
      hotkeyDisplay: '4',
    },
    ThirdBase: {
      hotkeyCode: 53,
      hotkeyDisplay: '5',
    },
    Pitcher: {
      hotkeyCode: 49,
      hotkeyDisplay: '1',
    },
    FirstBase: {
      hotkeyCode: 51,
      hotkeyDisplay: '3',
    },
    Catcher: {
      hotkeyCode: 50,
      hotkeyDisplay: '2',
    },
  },
  Result: {
    StolenBase: {
      hotkeyCode: 83,
      hotkeyDisplay: 'S',
    },
    CaughtStealing: {
      hotkeyCode: 68,
      hotkeyDisplay: 'D',
    },
    Nothing: {
      hotkeyCode: 78,
      hotkeyDisplay: 'N',
    },
  },
  PitchType: {
    FastBall: {
      hotkeyCode: 70,
      hotkeyDisplay: 'F',
    },
    FourSeamFastBall: {
      hotkeyCode: 52,
      hotkeyDisplay: '4',
    },
    TwoSeamFastBall: {
      hotkeyCode: 50,
      hotkeyDisplay: '2',
    },
    OneSeamFastBall: {
      hotkeyCode: 49,
      hotkeyDisplay: '1',
    },
    Sinker: {
      hotkeyCode: 83,
      hotkeyDisplay: 'S',
    },
    Slider: {
      hotkeyCode: 76,
      hotkeyDisplay: 'L',
    },
    Splitter: {
      hotkeyCode: 80,
      hotkeyDisplay: 'P',
    },
    Cutter: {
      hotkeyCode: 67,
      hotkeyDisplay: 'C',
    },
    Curveball: {
      hotkeyCode: 85,
      hotkeyDisplay: 'U',
    },
    ChangeUp: {
      hotkeyCode: 72,
      hotkeyDisplay: 'H',
    },
    Knuckleball: {
      hotkeyCode: 75,
      hotkeyDisplay: 'K',
    },
    Other: {
      hotkeyCode: 79,
      hotkeyDisplay: 'O',
    },
    Sweeper: {
      hotkeyCode: 87,
      hotkeyDisplay: 'W',
    },
  },
};
